import { v4 as uuid } from 'uuid';
import facebook from './facebook.svg';
import instagram from './instagram.svg';
import linkedin from './linkedin.svg';
import { styleHelper } from './styleHelper';


const createColumn = (columns) => {
    const sectionColumns = columns.map(col => {
        return styleHelper().initColumn(col)
    });
    return sectionColumns;
}

// Create section with column by layout 
export const createSectionLayout = (layout) => {
    let columns = [];
    switch (layout) {
        case "single-column":
            columns = createColumn([100]);
            break;
        case "two-column":
            columns = createColumn([50, 50]);
            break;
        case "2-3-column":
            columns = createColumn([40, 60]);
            break;
        case "3-2-column":
            columns = createColumn([60, 40]);
            break;
        case "three-column":
            columns = createColumn([33.33, 33.33, 33.33]);
            break;
        case "one-by-two-column":
            columns = createColumn([50, 25, 25]);
            break;
        case "two-by-one-column":
            columns = createColumn([25, 25, 50]);
            break;
        case "four-column":
            columns = createColumn([25, 25, 25, 25]);
            break;
        case "one-by-three-column":
            columns = createColumn([25, 75]);
            break;
        case "three-by-one-column":
            columns = createColumn([75, 25]);
            break;
        case "one-two-one-column":
            columns = createColumn([25, 50, 25]);
            break;
        case "4-2-2-2-column":
            columns = createColumn([40, 20, 20, 20]);
            break;
        case "five-column":
            columns = createColumn([20, 20, 20, 20, 20]);
            break;
        case "six-column":
            columns = createColumn([16.6667, 16.6667, 16.6667, 16.6667, 16.6667, 16.6667]);
            break;
        default:
            break;
    }
    return columns;
}


export const addComponent = (type) => {
    switch (type) {
        case 'heading':
            return {
                id: uuid(),
                type: type,
                data: 'Heading text',
                markup: 'h2',
                link: {
                    hasLink: false,
                    url: '',
                    newTab: false,
                    type: 'link',
                },
                style: {
                    padding: styleHelper().paddingResponsive(),
                    margin: styleHelper().marginResponsive(),
                    bgColor: styleHelper().bgColor,
                    text: styleHelper().textResponsive({ base: '24' }, '500', '#212121', { base: 'left' }),
                    maxWidth: '100%',
                    alignment: styleHelper().alignment('flex'),
                    // alignment: styleHelper().alignment('grid'),
                    headingLevel: 'h2',
                    transition: 0,
                    hover: styleHelper().hover(),
                    animation: styleHelper().animation(),

                },
                textShadow: {
                    hShadow: 0,
                    vShadow: 0,
                    blur: 0,
                    color: 'transparent',
                },
                textStroke: {
                    width: 0,
                    color: 'transparent',
                }
            }


        case 'paragraph':
            return {
                id: uuid(),
                type: type,
                data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s',
                link: {
                    hasLink: false,
                    url: '',
                    newTab: false,
                    type: 'link',
                },
                markup: 'p',
                style: {
                    padding: styleHelper().paddingResponsive(),
                    margin: styleHelper().marginResponsive(),
                    bgColor: styleHelper().bgColor,
                    text: styleHelper().textResponsive({ base: '16' }, '400', '#212121', { base: 'left' }),
                    maxWidth: '100%',
                    alignment: styleHelper().alignment('flex'),
                    hover: styleHelper().hover(),
                    transition: 0,
                    animation: styleHelper().animation(),

                },
                textShadow: {
                    hShadow: 0,
                    vShadow: 0,
                    blur: 0,
                    color: 'transparent',
                }
            }

        case 'image':
            return {
                id: uuid(),
                type: type,
                url: {
                    path: '',
                    altText: '',
                    id: ''
                },
                // imageInfo: {
                //     fileName: '',
                //     altText: '',
                //     id: '',
                //     caption: '',
                //     description: '',
                // },
                link: {
                    hasLink: false,
                    url: '',
                    newTab: false,
                    type: 'link',
                },
                style: {
                    padding: styleHelper().paddingResponsive(),
                    margin: styleHelper().marginResponsive(),
                    height: styleHelper().height('auto'),
                    width: styleHelper().width('100%'),
                    border: styleHelper().border(0, 'none', 'gray.300'),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                    justifyContent: styleHelper().alignment('flex'),
                    hover: styleHelper().hover(),
                    transition: 0,
                    animation: styleHelper().animation(),
                    visibility: styleHelper().visibility(),

                }
            }

        case 'video':
            return {
                id: uuid(),
                type: type,
                src: {
                    path: '',
                    altText: '',
                    type: 'internal',
                    link: '',
                    id: ''
                },
                link: {
                    hasLink: false,
                    url: '',
                    newTab: false
                },
                style: {
                    width: '100',
                    height: 'auto',
                    justifyContent: 'flex-start',
                }
            }

        case 'sliderLegecy':
            return {
                id: uuid(),
                type: type,
                items: [{
                    id: uuid(),
                    bgColor: '#cddafd',
                    bgImage: {
                        path: '',
                        altText: '',
                        id: ''
                    },
                    justifyContent: 'center',
                    alignItems: 'center',
                    innerAlignment: 'center',
                    margin: styleHelper().margin(),
                    link: {
                        hasLink: false,
                        url: '',
                        newTab: false
                    },
                    text: {
                        data: 'Paragraph Text',
                        padding: styleHelper().padding(0, 0, 0, 0),
                        margin: styleHelper().margin(),
                        font: styleHelper().text('14', '400'),
                        visibility: true
                    },
                    header: {
                        data: 'Header Text',
                        padding: styleHelper().padding(0, 0, 0, 0),
                        margin: styleHelper().margin(),
                        font: styleHelper().text('24', '700'),
                        visibility: true
                    },
                    button: {
                        data: 'Button Text',
                        padding: styleHelper().padding(4, 8, 4, 8),
                        margin: styleHelper().margin(),
                        height: 'auto',
                        width: 'auto',
                        visibility: true,
                        border: styleHelper().border(0, 0, 0, 0),
                        rounded: styleHelper().rounded(2, 2, 2, 2),
                        bgColor: 'gray.50',
                        font: styleHelper().text('14', '500'),
                        url: ''
                    }
                }],
                itemToShow: 1,
                autoPlay: true,
                padding: 0,
                height: 300,
                imageAs: 'background'
            }

        case 'button':
            return {
                id: uuid(),
                type: type,
                link: {
                    hasLink: false,
                    url: '',
                    newTab: false,
                    type: 'link',
                },
                data: 'Button Text',
                iconStyle: {
                    type: 'fontawesome-solid',
                    leftIcon: 'star',
                    rightIcon: 'star',

                    // color: '#6d7882',
                    // background: '#fff',
                    // size: 20,
                },
                style: {
                    isLeftIcon: false,
                    isRightIcon: false,
                    padding: styleHelper().paddingResponsive(10, 20, 10, 20),
                    margin: styleHelper().marginResponsive(0, 0, 0, 0),
                    height: 'auto',
                    width: 'auto',
                    border: styleHelper().border(0),
                    rounded: styleHelper().rounded(4),
                    bgColor: '#CBD5E0',
                    text: styleHelper().textResponsive({ base: '16' }, '400', '#212121', { base: 'left' }),
                    justifyContent: styleHelper().alignment('flex'),
                    transition: 0,
                    hover: styleHelper().hover(),
                    animation: styleHelper().animation(),
                }
            }

        case 'divider':
            return {
                id: uuid(),
                type: type,
                style: {
                    margin: styleHelper().marginResponsive(10, 0, 10, 0),
                    width: styleHelper().width('100%'),
                    border: styleHelper().border(3),
                    rounded: styleHelper().rounded(2),
                    justifyContent: styleHelper().alignment('flex'),
                }
            }

        case 'icon':
            return {
                id: uuid(),
                type: type,
                iconStyle: {
                    name: 'star',
                    type: 'fontawesome-solid',
                    color: '#6d7882',
                    background: '#fff',
                    size: 20,
                    padding: styleHelper().paddingResponsive(),
                    margin: styleHelper().marginResponsive(),
                    // padding: styleHelper().padding(),
                    // margin: styleHelper().margin(),
                    width: '100%',
                    border: styleHelper().border(0),
                    borderRadius: 0,
                    justifyContent: styleHelper().alignment('flex'),
                    // justifyContent: 'flex-start',
                    transition: 0,
                    hover: styleHelper().hover('#6d7882'),
                    animation: styleHelper().animation(),
                }
            }

        case 'sitelogo':
            return {
                id: uuid(),
                type: type,
                style: {
                    margin: styleHelper().marginResponsive(),
                    padding: styleHelper().paddingResponsive(),
                    width: '200px',
                    height: 'auto',
                    objectFit: 'contain',
                    justifyContent: styleHelper().alignment('flex'),
                    alignItems: "flex-start",
                    transition: 0,
                    hover: styleHelper().hover(),
                    animation: styleHelper().animation(),
                    link: '/'
                }
            }

        case 'text-divider':
            return {
                id: uuid(),
                type: type,
                data: 'Divider',
                style: {
                    margin: styleHelper().marginResponsive(10, 0, 10, 0),
                    width: styleHelper().width('100%'),
                    justifyContent: styleHelper().alignment('flex'),
                    gap: 0,
                },
                textStyle: {
                    margin: styleHelper().marginResponsive(),
                    text: styleHelper().textResponsive({ base: '16' }, '400', '#212121', { base: 'left' }),
                    hideText: false
                },
                dividerStyleOne: {
                    border: styleHelper().border(2, 'solid', '#3F3047'),
                    rounded: styleHelper().rounded(0),
                    width: styleHelper().width('100%'),

                },
                dividerStyleTwo: {
                    border: styleHelper().border(2, 'solid', '#3F3047'),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                    width: styleHelper().width('100%'),

                }
            }

        case 'html':
            return {
                id: uuid(),
                type: type,
                style: {
                    width: '100%',
                    margin: styleHelper().margin(0, 0, 0, 0),
                    padding: styleHelper().padding(8, 8, 8, 8),
                    alignment: 'flex-start'
                },
                markup: ``,
                jsCode: ``,
                cssCode: ``,
                darkMode: false,
                editorStyle: {
                    fontSize: '14px',
                    fontFamily: 'Poppins',
                    height: '200px',
                    background: 'black',
                    padding: '15px',
                    codeSuggestion: false, //heavy size packages needed
                    theme: 'default' //similar to background - theme or bg --select one
                }

            }

        case 'image-carousel':
            return {
                id: uuid(),
                type: type,
                items: [
                    {
                        id: uuid(),
                        title: 'Title',
                        link: '',
                        newTab: false,
                        image: {
                            path: '',
                            altText: 'Demo Image',
                            id: ''
                        },
                    }
                ],
                style: {
                    margin: styleHelper().margin(),
                    padding: styleHelper().padding(),
                    width: '100%',
                    height: 350,
                    showSettings: true,
                    activeIndex: 0,
                    alignment: 'flex-start',
                    transition: 0,
                    hover: styleHelper().hover(),
                },
                textStyle: {
                    toggleTitle: false,
                    margin: styleHelper().margin(0, 0, 0, 0),
                    padding: styleHelper().padding(),
                    font: styleHelper().text('25', '700', 'white', 'center'),
                },
                imageStyle: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesToScroll: 3,
                    speed: 500,
                    effect: 'scroll',
                    borderRadius: 0,
                    objectFit: 'cover',
                    activeTint: false,
                    tintValue: .4
                },
                controlStyle: {
                    autoplay: false,
                    autoplayInterval: 3000,
                    loop: true,
                    dragging: true,
                    hideControls: false,
                    pauseOnHover: false

                },
                navigationStyle: {
                    iconStyle: 'arrow',
                    color: 'white',
                    size: 30,
                    active: false,
                    margin: '5px'
                },
                paginationStyle: {
                    active: false,
                    color: 'white',
                    size: 1,
                    gap: 5
                }

            }

        case 'media-carousel':
            return {
                id: uuid(),
                type: type,
                items: [
                    {
                        itemType: 'image',
                        id: uuid(),
                        title: 'Title',
                        link: '',
                        image: {
                            path: '',
                            altText: 'Demo Image',
                            id: ''
                        },
                        newTab: false,

                    },
                    {
                        itemType: 'image',
                        id: uuid(),
                        title: 'Title',
                        link: '',
                        image: {
                            path: '',
                            altText: 'Demo Image',
                            id: ''
                        },
                        newTab: false,
                    }
                ],
                style: {
                    margin: styleHelper().margin(),
                    padding: styleHelper().padding(),
                    width: '100%',
                    height: 350,
                    showSettings: true,
                    activeIndex: 0,
                    alignment: 'flex-start',
                },
                textStyle: {
                    toggleTitle: false,
                    margin: styleHelper().margin(0, 0, 0, 0),
                    padding: styleHelper().padding(),
                    font: styleHelper().text('25', '700', 'white', 'center'),
                },
                imageStyle: {
                    slidesPerView: 2,
                    spaceBetween: 5,
                    slidesToScroll: 3,
                    speed: 500,
                    effect: 'scroll',
                    borderRadius: 0,
                    objectFit: 'cover',
                    activeTint: false,
                    tintValue: .4
                },
                controlStyle: {
                    autoplay: false,
                    autoplayInterval: 3000,
                    loop: true,
                    dragging: true,
                    hideControls: false,
                    pauseOnHover: false

                },
                navigationStyle: {
                    iconStyle: 'arrow',
                    color: 'white',
                    size: 30,
                    active: false,
                    margin: '5px'
                },
                paginationStyle: {
                    active: false,
                    color: 'white',
                    size: 1,
                    gap: 5
                }

            }


        case 'image-gallery':
            return {
                id: uuid(),
                type: type,
                items: [
                    {
                        id: uuid(),
                        title: 'Title',
                        subTitle: 'Subtitle',
                        link: '',
                        newTab: false,
                        image: {
                            path: 'https://images.unsplash.com/photo-1642952868265-6414b8424c60?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyOHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=60',
                            altText: 'Demo Image',
                            id: ''
                        },
                    },
                    {
                        id: uuid(),
                        title: 'Title',
                        subTitle: 'Subtitle',
                        link: '',
                        newTab: false,
                        image: {
                            path: 'https://images.unsplash.com/photo-1642948816628-9b457871592d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwzMHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=60',
                            altText: 'Demo Image',
                            id: ''
                        },
                    },
                    {
                        id: uuid(),
                        title: 'Title',
                        subTitle: 'Subtitle',
                        link: '',
                        newTab: false,
                        image: {
                            path: 'https://images.unsplash.com/photo-1536329583941-14287ec6fc4e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwzMXx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=60',
                            altText: 'Demo Image',
                            id: ''
                        },
                    },
                    {
                        id: uuid(),
                        title: 'Title',
                        subTitle: 'Subtitle',
                        link: '',
                        newTab: false,
                        image: {
                            path: 'https://images.unsplash.com/photo-1599420186946-7b6fb4e297f0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHw0MHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=60',
                            altText: 'Demo Image',
                            id: ''
                        },
                    },
                    {
                        id: uuid(),
                        title: 'Title',
                        subTitle: 'Subtitle',
                        link: '',
                        newTab: false,
                        image: {
                            path: 'https://images.unsplash.com/photo-1642960974342-98254ee6ecfd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw1N3x8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=60',
                            altText: 'Demo Image',
                            id: ''
                        },
                    },
                    {
                        id: uuid(),
                        title: 'Title',
                        subTitle: 'Subtitle',
                        link: '',
                        newTab: false,
                        image: {
                            path: 'https://images.unsplash.com/photo-1558980394-dbb977039a2e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=3450&q=80',
                            altText: 'Demo Image',
                            id: ''

                        }
                    },
                    {
                        id: uuid(),
                        title: 'Title',
                        subTitle: 'Subtitle',
                        link: '',
                        newTab: false,
                        image: {
                            path: 'https://images.unsplash.com/photo-1642952867267-533b87bea300?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxNXx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=60',
                            altText: 'some text',
                            id: ''
                        }
                    },
                    {
                        id: uuid(),
                        title: 'Title',
                        subTitle: 'Subtitle',
                        link: '',
                        newTab: false,
                        image: {
                            path: 'https://images.unsplash.com/photo-1642960972173-1906963af926?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyNHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=60',
                            altText: 'source image',
                            id: ''
                        }
                    }
                ],
                style: {
                    width: '100%',
                    margin: styleHelper().margin(0, 0, 0, 0),
                    padding: styleHelper().padding(0, 0, 0, 0),
                    alignment: 'flex-start',
                    columnCount: 3,
                    columnGap: 10,
                    rowGap: 15,

                },
                imageStyle: {
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    borderRadius: 3,
                    hoverEffect: 'scale(1)',
                    filterEffect: 'none',
                    isFilterActive: true,
                    isThumbnailActive: false
                },
                titleStyle: {
                    margin: styleHelper().margin(0, 0, 0, 0),
                    padding: styleHelper().padding(),
                    font: styleHelper().text('16', '700', 'white', 'center'),
                },
                subtitleStyle: {
                    margin: styleHelper().margin(0, 0, 0, 0),
                    padding: styleHelper().padding(),
                    font: styleHelper().text('14', '500', 'white', 'center'),
                },
            }

        case 'feature':
            return {
                id: uuid(),
                type: type,
                items: [
                    {
                        id: uuid(),
                        image: {
                            path: 'https://via.placeholder.com/300x300/CBD5E0/718096/?text=Image',
                            altText: 'Demo Image',
                            id: ''
                        },
                        title: "Title",
                        subtitle: "Some Text",
                        startValue: 0,
                        endValue: 100,
                        isCounterActive: false,
                    },
                ],
                style: {
                    margin: styleHelper().margin(),
                    padding: styleHelper().padding(),
                    width: '100%',
                    height: 'auto',
                    alignment: 'flex-start',
                    direction: 'row',
                    rowGap: 10,
                    columnGap: 2,
                    gap: 1
                },
                cardStyle: {
                    padding: styleHelper().padding(),
                    width: '25%',
                    rowWidth: 'auto', //for left/right image position
                    height: 'auto',
                    direction: 'column',
                    alignSelf: 'center',
                    gap: 5,
                    alignment: 'center',
                },
                imageStyle: {
                    width: '100%',
                    height: '200px',
                    borderRadius: 3
                },
                titleStyle: {
                    margin: styleHelper().margin(0, 0, 0, 0),
                    padding: styleHelper().padding(),
                    font: styleHelper().text('16', '700', 'gray.900', 'center'),
                },
                subtitleStyle: {
                    margin: styleHelper().margin(0, 0, 0, 0),
                    padding: styleHelper().padding(0, 0, 0, 0),
                    font: styleHelper().text('14', '500', 'gray.700', 'center'),
                },
                counterStyle: {
                    duration: 10,
                    delay: 0,
                }
            }

        case 'testimonial':
            return {
                id: uuid(),
                type: type,

                items: [{
                    id: uuid(),
                    bgColor: '#cddafd',
                    newTab: false,
                    image: {
                        path: '',
                        altText: '',
                        id: ''
                    },
                    heading: {
                        data: 'John Doe'
                    },
                    subHeading: {
                        data: 'Creative Designer'
                    },
                    text: {
                        data: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla egestas malesuada libero, id ultrices massa auctor at.'
                    },
                    socialLinks: [
                        {
                            id: uuid(),
                            name: 'Facebook',
                            icon: 'facebook',
                            link: ''
                        },

                        {
                            id: uuid(),
                            name: 'Twitter',
                            icon: 'twitter',
                            link: ''
                        },

                        {
                            id: uuid(),
                            name: 'LinkedIn',
                            icon: 'linkedin',
                            link: ''
                        }
                    ]

                },
                ],
                controlStyle: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesToScroll: 3,
                    speed: 1000,
                    effect: 'scroll',
                },
                itemToShow: 1,
                autoPlay: false,
                duration: 5000,
                padding: 0,
                height: 350,
                image: {
                    margin: styleHelper().marginResponsive(0, 0, 5, 0),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    border: styleHelper().border(0),
                    rounded: styleHelper().rounded(50),
                    transition: 0,
                    hover: styleHelper().hover(),
                },

                heading: {
                    margin: styleHelper().marginResponsive(0, 0, 5, 0),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    font: styleHelper().textResponsive({ base: '18' }, '700', '#4a4a4a', { base: 'left' }),
                    fontFamily: 'Poppins',
                    visibility: true
                },
                subHeading: {
                    margin: styleHelper().marginResponsive(0, 0, 5, 0),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    font: styleHelper().textResponsive({ base: '14' }, '500', '#9b9b9b', { base: 'left' }),
                    fontFamily: 'Poppins',
                    visibility: true
                },
                text: {
                    margin: styleHelper().marginResponsive(0, 0, 5, 0),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    font: styleHelper().textResponsive({ base: '22' }, '400', '#6b7072', { base: 'left' }),
                    fontFamily: 'Poppins',
                    visibility: true
                },
                navigationStyle: {
                    iconStyle: 'arrow',
                    color: '#CBD5E0',
                    size: 30,
                    active: true,
                    margin: '5px'
                },
                paginationStyle: {
                    active: true,
                    color: '#CBD5E0',
                    size: 1,
                    gap: 5
                }
            }

        case 'mediaObject':
            return {
                id: uuid(),
                type: type,

                style: {
                    width: '100%',
                    justifyContent: styleHelper().alignment('flex'),
                    // justifyContent: 'flex-start',
                    margin: styleHelper().margin(0, 0, 15, 0),
                    transition: 0,
                    hover: styleHelper().hover(),
                    animation: styleHelper().animation(),

                },

                items: [{
                    id: uuid(),
                    bgColor: '#cddafd',
                    newTab: false,
                    image: {
                        path: '',
                        altText: '',
                        id: ''
                    },
                    heading: {
                        data: 'Heading'
                    },
                    subHeading: {
                        data: 'Sub Heading'
                    },
                    text: {
                        data: 'Lorem ipsum dolor sit amet, consectetur.'
                    },
                    link: {
                        url: '',
                        type: 'link',
                        isActive: true,
                        openInNewTab: false,
                    }
                }],

                image: {
                    margin: styleHelper().margin(0, 0, 5, 0),
                    padding: styleHelper().padding(0, 0, 0, 0),
                    border: styleHelper().border(0),
                    rounded: styleHelper().rounded(2),
                    width: '100px',
                    height: '100',
                    alignment: 'left'
                },

                heading: {
                    margin: styleHelper().marginResponsive(0, 0, 5, 0),
                    padding: styleHelper().padding(0, 0, 0, 0),
                    font: styleHelper().textResponsive({ base: '18' }, '700', '#4a4a4a', { base: 'left' }, 'uppercase'),
                    fontFamily: 'Poppins',
                    visibility: true
                },

                subHeading: {
                    margin: styleHelper().marginResponsive(0, 0, 0, 0),
                    padding: styleHelper().padding(0, 0, 0, 0),
                    font: styleHelper().textResponsive({ base: '14' }, '500', '#9b9b9b', { base: 'left' }),
                    fontFamily: 'Poppins',
                    visibility: true
                },

                text: {
                    padding: styleHelper().padding(0, 0, 0, 0),
                    margin: styleHelper().marginResponsive(0, 0, 0, 0),
                    font: styleHelper().textResponsive({ base: '16' }, '500', '#6b7072', { base: 'left' }),
                    fontFamily: 'Poppins',
                    visibility: true
                },

                button: {
                    padding: styleHelper().padding(0, 0, 0, 0),
                    margin: styleHelper().margin(0, 0, 10, 0),
                    border: styleHelper().border(0),
                    rounded: styleHelper().rounded(50),
                    font: styleHelper().text('16', '400', '#6b7072'),
                    fontFamily: 'Poppins',
                    visibility: false
                },
            }

        case 'list':
            return {
                id: uuid(),
                type: type,
                style: {
                    padding: styleHelper().paddingResponsive(10, 10, 10, 10),
                    margin: styleHelper().marginResponsive(),
                    bgColor: styleHelper().bgColor,
                    width: '100%',
                    text: styleHelper().textResponsive({ base: '16' }, '400'),
                    iconColor: '#212121',
                    iconGap: 10,
                    border: styleHelper().border(0),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                    justifyContent: styleHelper().alignment('flex'),
                    animation: styleHelper().animation(),

                },
                listStyle: 'unordered',
                listIcon: "none",
                iconAlignment: "left",
                listItems: [
                    {
                        id: uuid(), text: 'List text',
                        newTab: false,
                        link: {
                            "url": "",
                            "type": "link"
                        }
                    }
                ]
            }

        case 'accordion':
            return {
                id: uuid(),
                type: type,
                style: {
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    margin: styleHelper().marginResponsive(),
                    bgColor: styleHelper().bgColor,
                    width: '100%',
                    border: styleHelper().border(0),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                    justifyContent: styleHelper().alignment('flex'),
                },

                headingStyle: {
                    text: styleHelper().textResponsive({ base: '16' }, '500'),
                },
                textStyle: {
                    text: styleHelper().textResponsive({ base: '15' }, '400'),
                },
                iconStyle: {
                    alignment: 'left'
                },

                items: [
                    { id: uuid(), heading: 'Heading text', text: 'Content text' }
                ]
            }

        case 'menus':
            return {
                id: uuid(),
                type: type,

                title: 'Menu Title',
                dataSource: '',

                style: {
                    margin: styleHelper().marginResponsive(),
                    padding: styleHelper().paddingResponsive(10, 10, 10, 10),
                    display: true,
                    // justifyContent: 'flex-start'
                },

                menuStyle: {
                    gap: 5,
                    padding: styleHelper().paddingResponsive(4, 0, 4, 0),
                    font: styleHelper().text('15', '400'),
                    fontFamily: 'Poppins',
                    orientation: styleHelper().orientation('vertical'),
                    // orientation: 'vertical',
                    // justifyContent: 'flex-start'
                    justifyContent: styleHelper().alignment('flex'),
                    iconColor: 'black',
                    menuOpenTime: 'hover'
                },

                titleStyle: {
                    margin: styleHelper().marginResponsive(),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    font: styleHelper().text('15', '400'),
                    fontFamily: 'Poppins',
                }
            }

        case 'blog-grid':
            return {
                id: uuid(),
                type: type,
                cardBgColor: 'red',
                style: {
                    margin: styleHelper().margin(),
                    numberOfColumn: { base: 1, md: 2, lg: 3 },
                    columnGap: 10,
                    rowGap: 20,
                    animation: styleHelper().animation(),
                    layout: 'grid',
                    width: "100%",
                    justifyContent: styleHelper().alignment('flex'),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                },

                cardStyle: {
                    margin: styleHelper().marginResponsive(),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    border: styleHelper().border(1, 'solid', 'gray.300'),
                    rounded: styleHelper().rounded(8, 8, 8, 8),
                    bgColor: "#FFFFFF",
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    position: 'relative',
                    textAlign: 'center',
                    showTags: true,
                    showCategories: true,
                    showTitle: true,
                    showExcerpt: true,
                    showComments: true,
                    showAuthor: true,
                },

                searchStyle: {
                    showSearchBar: true,
                    justifyContent: styleHelper().alignment('flex'),
                    height: 'auto',
                    width: '60%',
                    border: styleHelper().border(0),
                    rounded: styleHelper().rounded(4),
                    bgColor: '#CBD5E0',
                    text: styleHelper().textResponsive({ base: '16' }, '400', '#212121', { base: 'left' }),
                    margin: styleHelper().marginResponsive(0, 0, 0, 0),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    searchText: 'Search',
                    searchContainerWidth: '40%',
                },

                paginationStyle: {
                    showPagination: true,
                    paginateView: 'button',
                    margin: styleHelper().marginResponsive(0, 0, 0, 0),
                    selectedPageColor: 'blue.400',
                    buttonVariant: 'outline',
                    color: 'blue.400'
                },
                filterStyle: {
                    showFilter: true,
                    justifyContent: styleHelper().alignment('flex', 'right'),
                    text: styleHelper().textResponsive({ base: '16' }, '400', '#212121', { base: 'left' }),
                    margin: styleHelper().marginResponsive(0, 0, 0, 0),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    filterText: 'Filter by tags',
                    filterView: 'dropdown',
                    width: '40%',
                    filterContainerWidth: '60%'
                },

                categoryStyle: {
                    showCategory: true,
                    justifyContent: styleHelper().alignment('flex', 'left'),
                    text: styleHelper().textResponsive({ base: '16' }, '400', '#212121', { base: 'left' }),
                    margin: styleHelper().marginResponsive(0, 0, 0, 0),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    categoryText: 'Select Category',
                    categoryView: 'dropdown',
                    width: '340px',
                    containerWidth: '60%'
                },


                imageStyle: {
                    margin: styleHelper().marginResponsive(0, 0, 10, 0),
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    width: '100%',
                    height: '200',
                    border: styleHelper().border(0, 'none', 'gray.300'),
                    rounded: styleHelper().rounded(8, 8, 0, 0),
                    justifyContent: "flex-start"
                },

                title: {
                    markup: 'h2',
                    margin: styleHelper().marginResponsive(10, 10, 10, 10),
                    padding: styleHelper().paddingResponsive(),
                    text: styleHelper().textResponsive({ base: '15' }, '500', '#545e6f'),
                    limit: 10
                },
                excerpt: {
                    markup: 'p',
                    margin: styleHelper().marginResponsive(10, 10, 10, 10),
                    padding: styleHelper().paddingResponsive(),
                    text: styleHelper().textResponsive({ base: '14' }, '400', '#545e6f'),
                    limit: 20
                },
                button: {
                    margin: styleHelper().marginResponsive(0, 0, 10, 0),
                    padding: styleHelper().paddingResponsive(4, 10, 4, 10),
                    height: 'auto',
                    width: 'auto',
                    border: styleHelper().border(1, 'solid', 'rgba(74,144,226,1)'),
                    rounded: styleHelper().rounded(7, 7, 7, 7),
                    bgColor: 'transparent',
                    text: styleHelper().textResponsive({ base: '12' }, '300', 'gray.900'),
                    justifyContent: "flex-start",
                    visibility: true,
                    data: 'Read More'
                },

                data: {
                    dataSource: null,
                    dataSourceType: 'all',
                    limit: 10,
                    filter: {
                        type: 'author',
                        value: null,
                    },
                    sort: [{ label: 'Date', value: 'createdAt', type: 'desc' }]
                }

            }

        case 'rentmy':
            return {
                id: uuid(),
                type: type,

                style: {
                    margin: styleHelper().margin(),
                    numberOfColumn: 4,
                    columnGap: 10,
                    rowGap: 20
                },

                cardStyle: {
                    margin: styleHelper().margin(),
                    padding: styleHelper().padding(10, 10, 10, 10),
                    border: styleHelper().border(1, 'solid', 'gray.300'),
                    rounded: styleHelper().rounded(8, 8, 8, 8),
                    bgColor: "#FFFFFF",
                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                    position: 'relative',
                    textAlign: 'center',
                },

                imageStyle: {
                    margin: styleHelper().margin(0, 0, 10, 0),
                    padding: styleHelper().padding(0, 0, 0, 0),
                    width: '100%',
                    height: '160',
                    border: styleHelper().border(0, 'none', 'gray.300'),
                    rounded: styleHelper().rounded(8, 8, 0, 0),
                    justifyContent: "flex-start"
                },

                title: {
                    markup: 'h3',
                    margin: styleHelper().margin(0, 0, 5, 0),
                    padding: styleHelper().padding(),
                    text: styleHelper().text('15', '700', 'gray.900'),
                    limit: 10
                },
                excerpt: {
                    markup: 'p',
                    margin: styleHelper().margin(0, 0, 10, 0),
                    padding: styleHelper().padding(),
                    text: styleHelper().text('14', '400', 'gray.700'),
                    limit: 20
                },

                data: {
                    dataSource: null,
                    locationDataSource: null,
                    dataSourceType: 'all',
                    limit: 10,
                    sort: [{ label: 'Date', value: 'createdAt', type: 'desc' }]
                }

            }

        case 'rentMyWithFilters':
            return {
                id: uuid(),
                type: type,

                style: {
                    margin: styleHelper().margin(),
                    numberOfColumn: 4,
                    columnGap: 10,
                    rowGap: 20,
                    alignProduct: 'row',
                    alignSearch: 'flex-start',
                },

                cardStyle: {
                    margin: styleHelper().margin(),
                    padding: styleHelper().padding(10, 10, 10, 10),
                    border: styleHelper().border(1, 'solid', 'gray.300'),
                    rounded: styleHelper().rounded(8, 8, 8, 8),
                    bgColor: "#FFFFFF",
                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                    position: 'relative',
                    textAlign: 'center',
                },

                imageStyle: {
                    margin: styleHelper().margin(0, 0, 10, 0),
                    padding: styleHelper().padding(0, 0, 0, 0),
                    width: '100%',
                    height: '160',
                    border: styleHelper().border(0, 'none', 'gray.300'),
                    rounded: styleHelper().rounded(8, 8, 0, 0),
                    justifyContent: "flex-start"
                },

                title: {
                    markup: 'h3',
                    margin: styleHelper().margin(0, 0, 5, 0),
                    padding: styleHelper().padding(),
                    text: styleHelper().text('15', '700', 'gray.900'),
                    limit: 10
                },
                excerpt: {
                    markup: 'p',
                    margin: styleHelper().margin(0, 0, 10, 0),
                    padding: styleHelper().padding(),
                    text: styleHelper().text('14', '400', 'gray.700'),
                    limit: 20
                },

                data: {
                    dataSource: null,
                    locationDataSource: null,
                    dataSourceType: 'all',
                    limit: 10,
                    sort: [{ label: 'Date', value: 'createdAt', type: 'desc' }]
                },

                filters: {
                    search: {
                        show: true,
                        style: {

                        }
                    },
                    categories: {
                        show: true,
                        style: {

                        }
                    },
                    filter: {
                        show: true,
                        style: {

                        }
                    },
                    priceRange: {
                        show: true,
                        style: {

                        }
                    },
                    tags: {
                        show: true,
                        style: {

                        }
                    },
                    types: {
                        show: true,
                        style: {

                        }
                    },
                    sorting: {
                        show: true,
                        style: {

                        }
                    },
                    pagination: {
                        show: true,
                        type: 'text',
                        style: {

                        }
                    },


                }

            }

        case 'rentMyCustomerRegistration':
            return {
                id: uuid(),
                type: type,

                style: {
                    padding: styleHelper().paddingResponsive(),
                    margin: styleHelper().marginResponsive(),
                    justifyContent: styleHelper().alignment('flex'),
                    height: '300px',
                    width: '100%',
                    border: styleHelper().border(0, 'none', 'gray'),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                }

            }

        case 'rentMyCustomerLogin':
            return {
                id: uuid(),
                type: type,

                style: {
                    padding: styleHelper().paddingResponsive(),
                    margin: styleHelper().marginResponsive(),
                    justifyContent: styleHelper().alignment('flex'),
                    height: '300px',
                    width: '100%',
                    border: styleHelper().border(0, 'none', 'gray'),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                }

            }

        case 'rentMyCustomerResetPass':
            return {
                id: uuid(),
                type: type,

                style: {
                    padding: styleHelper().paddingResponsive(),
                    margin: styleHelper().marginResponsive(),
                    justifyContent: styleHelper().alignment('flex'),
                    height: '300px',
                    width: '100%',
                    border: styleHelper().border(0, 'none', 'gray'),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                }

            }

        case 'rentMyProductList':
            return {
                id: uuid(),
                type: type,

                style: {
                    padding: styleHelper().paddingResponsive(),
                    margin: styleHelper().marginResponsive(),
                    justifyContent: styleHelper().alignment('flex'),
                    height: '300px',
                    width: '100%',
                    border: styleHelper().border(0, 'none', 'gray'),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                }

            }

        case 'social-icon':
            const id1 = uuid();
            const id2 = uuid();
            const id3 = uuid();
            return {
                id: uuid(),
                type: type,
                icons: [
                    {
                        id: id1,
                        name: 'Facebook',
                        image: { path: '', altText: 'facebook-icon', id: '' },
                        url: '',
                        defaultIcon: facebook,
                        newTab: false,
                    },
                    {
                        id: id2,
                        name: 'Linkedin',
                        image: { path: '', altText: 'linkedin-icon', id: '' },
                        url: '',
                        defaultIcon: linkedin,
                        newTab: false,

                    },
                    {
                        id: id3,
                        name: 'Instagram',
                        image: { path: '', altText: 'instagram-icon', id: '' },
                        url: '',
                        defaultIcon: instagram,
                        newTab: false
                    }
                ],
                style: {
                    align: styleHelper().alignment('flex'),
                    // align: "flex-start",
                    width: 32,
                    height: 32,
                    padding: styleHelper().padding(),
                    // margin: styleHelper().margin(),
                    margin: styleHelper().marginResponsive(),
                    spacing: 10,
                    transition: 0,
                    hover: styleHelper().hover(),
                    animation: styleHelper().animation(),

                }
            }

        case 'form':
            return {
                id: uuid(),
                type: type,
                name: 'My Form',
                fields: [
                    {
                        id: uuid(),
                        label: 'Name',
                        type: 'text',
                        name: 'name',
                        value: '',
                        placeholder: 'Name',
                        required: false,
                        width: 100
                    },
                    {
                        id: uuid(),
                        label: 'Email',
                        type: 'email',
                        name: 'email',
                        value: '',
                        placeholder: 'Email',
                        required: false,
                        width: 100
                    }
                ],
                button: {
                    text: 'Submit'
                },

                captchaStyle: {
                    isEnabled: true,
                    type: 'default',
                    label: 'Enter Captcha',
                    value: '',
                    limit: 6,
                    bgColor: '#FFFFFF',
                    text: styleHelper().textResponsive({ base: '24' }, '800', '#212121', { base: 'left' }, 'none', 1.5, 15,
                        'Arbutus',
                        'normal',
                        'none')
                },
                actions: [],
                formStyle: {
                    // width: '100',
                    width: styleHelper().width('100%'),
                    alignment: 'flex-start',
                    bgColor: '#FFFFFF',
                    border: styleHelper().border(0),
                    padding: styleHelper().paddingResponsive(15, 15, 15, 15),
                    // padding: styleHelper().padding(15, 15, 15, 15),
                    margin: styleHelper().margin(),
                    columnGap: '0',
                    rowGap: '10',
                },

                inputStyle: {
                    size: 'md',
                    variant: 'outline',
                    color: '#212121',
                    fontSize: '14',
                    fontFamily: 'Poppins',
                    border: styleHelper().border(1, 'solid', 'gray.200'),
                    rounded: styleHelper().rounded(4, 4, 4, 4),
                    placeholderColor: 'gray.400',
                    inputBorderColor: '#E2E8F0',
                    textDecoration: 'none',
                    fontStyle: 'normal'
                },

                labelStyle: {
                    fontSize: 14,
                    fontFamily: 'Poppins',
                    color: '#212121',
                    gap: 8,
                    display: true,
                    textDecoration: 'none',
                    fontStyle: 'normal'
                },

                buttonStyle: {
                    fullWidth: false,
                    size: 'md',
                    bgColor: '#E2E8F0',
                    padding: styleHelper().paddingResponsive(10, 25, 10, 25),
                    // padding: styleHelper().padding(10, 25, 10, 25),
                    justifyContent: styleHelper().alignment('flex'),
                    fontSize: '16',
                    fontFamily: 'Poppins',
                    color: '#212121',
                    border: styleHelper().border(0, 'solid', 'gray.400'),
                    rounded: styleHelper().rounded(4, 4, 4, 4),
                    buttonBorderColor: '#bdbdbd',
                    textDecoration: 'none',
                    fontStyle: 'normal'
                }
            }

        case 'google-map':
            return {
                id: uuid(),
                iframe: ``,
                apiKey: ``,
                type: type,
                isEmbed: true,
                center: { lat: 0, long: 0 },
                zoom: 2,
                maptype: `roadmap`,
                marker: ``,

                url: {
                    path: '',
                    altText: '',
                    id: ''
                },
                link: {
                    hasLink: false,
                    url: '',
                    newTab: false
                },
                style: {
                    padding: styleHelper().paddingResponsive(),
                    margin: styleHelper().marginResponsive(),
                    justifyContent: styleHelper().alignment('flex'),
                    // justifyContent: "flex-start"
                    // padding: styleHelper().padding(),
                    // margin: styleHelper().margin(),
                    height: '300px',
                    width: '100%',
                    border: styleHelper().border(0, 'none', 'gray'),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                }
            }


        case 'progress':
            return {
                id: uuid(),
                value: 20,
                min: 0,
                max: 100,
                hasStripe: false,
                barColor: `green`,
                background: `#e2e8f0`,

                iframe: ``,
                apiKey: ``,
                type: type,
                isEmbed: true,
                center: { lat: 0, long: 0 },
                zoom: 2,
                maptype: `roadmap`,
                marker: ``,

                url: {
                    path: '',
                    altText: '',
                    id: ''
                },
                link: {
                    hasLink: false,
                    url: '',
                    newTab: false
                },
                style: {
                    padding: styleHelper().padding(),
                    margin: styleHelper().margin(),
                    height: '20px',
                    width: '100%',
                    border: styleHelper().border(0, 'none', 'gray.300'),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                    justifyContent: "flex-start"
                }
            }

        case 'google-adsense':
            return {
                id: uuid(),
                type: type,
                style: {
                    width: '100%',
                    margin: styleHelper().margin(0, 0, 0, 0),
                    padding: styleHelper().padding(8, 8, 8, 8),
                    alignment: 'flex-start'
                },
                markup: ``,
                jsCode: ``,
                darkMode: false,
                editorStyle: {
                    fontSize: '14px',
                    fontFamily: 'Poppins',
                    height: '200px',
                    background: 'black',
                    padding: '15px',
                    codeSuggestion: false, //heavy size packages needed
                    theme: 'default' //similar to background - theme or bg --select one
                }

            }

        case 'tab':
            return {
                id: uuid(),
                type: type,
                style: {
                    padding: styleHelper().paddingResponsive(0, 0, 0, 0),
                    margin: styleHelper().marginResponsive(),
                    // padding: styleHelper().padding(0, 0, 0, 0),
                    // margin: styleHelper().margin(),
                    bgColor: styleHelper().bgColor,
                    width: '100%',
                    border: styleHelper().border(0),
                    rounded: styleHelper().rounded(0, 0, 0, 0),
                    justifyContent: styleHelper().alignment('flex'),
                    // justifyContent: "flex-start"
                },

                headerPosition: `top`,
                tabAlign: `start`,
                tabAutoFit: false,
                orientation: `horizontal`,
                tabSize: `md`,
                tabVariant: `line`,
                defaultTab: 0,

                headingStyle: {
                    text: styleHelper().textResponsive({ base: '16' }, '500'),
                },
                selectedStyle: {
                    // text: styleHelper().text('16', '500'),
                    color: `black.300`,
                    border: styleHelper().border(0),
                    bg: `gray.300`
                },
                textStyle: {
                    text: styleHelper().textResponsive({ base: '15' }, '400'),
                },
                iconStyle: {
                    alignment: 'left'
                },

                items: [
                    {
                        id: uuid(), heading: 'Tab name', text: 'Content text', disable: false,
                    }
                ]
            }

        default:
            return;
    }
}

export const deletableMedia = (component) => {
    const ids = [];
    switch (component.type) {
        case 'image':
            if (component.url.id) ids.push(component.url.id)
            break;

        case 'video':
            if (component.src.id) ids.push(component.src.id)
            break;

        case 'testimonial':
        case 'mediaObject':
        case 'image-carousel':
        case 'image-gallery':
            component.items.forEach(item => { if (item.image.id) ids.push(item.image.id) })
            break;

        case 'social-icon':
            component.icons.forEach(icon => { if (icon.image.id) ids.push(icon.image.id) })
            break;

        default:
            break;
    }

    return ids;
}

